import React, { useEffect, useState } from 'react'
import {
    Grid,
    Button,
    Typography,

} from "@material-ui/core";
import { PayDetailsHeader } from './constants';
import DynamicTable from './DynamicTable';
import PayDetailsModal from '../Modals/PayDetailsModal';
import services from '../../Services';
import roleManager from '../roles';

const { hr } = services;
var moment = require('moment-timezone')

const PayDetails = ({ tableData }) => {

    let { data, employeeDetails, setFlag } = tableData;
    const [paytypeDropdown, setPaytypeDropdown] = useState([]);

    const [updatePayDate, setUpdatePayDate] = useState('')
    const [openPay, setOpenPay] = useState(false)
    const [positionInformation, setPositionInformation] = useState(false)
    const [openPosition, setOpenPosition] = useState(false)
    const [updatePay, setUpdatePay] = useState({
        position_level: '',
        rate: '',
        pay_type: '',
        employee_id: '',
        vehicle_allowance: '',
        start_date: "",
        id: ''

    })

    { }

    function onUpdatePay(e) {
        e.preventDefault();

        let data = {
            position_level: 1,
            id: updatePay?.id,
            rate: updatePay?.rate,
            pay_type: updatePay?.pay_type?.id,
            employee_id: employeeDetails?.id,
            vehicle_allowance: updatePay?.vehicle_allowance,
            start_date: moment(updatePay?.updatedAt)?.format('YYYY-MM-DD'?.toString()),
        }
        try {
            if (updatePay?.task == 'add')
                hr?.updatePay(data).then((data) => {
                    setFlag(prev => { return prev = !prev })

                }).catch((err) => { });
            if (updatePay?.task == 'edit')
                hr?.editPay(data).then((data) => {
                    setFlag(prev => { return prev = !prev })
                }).catch((err) => { });
            setOpenPay(false)

        }
        catch (exc) {

        }
    }

    useEffect(async () => {

        let payLocationData = await hr.pay_type();
        setPaytypeDropdown(payLocationData.data);

    }, [])


    function editPay(row) {
        setUpdatePay({ ...updatePay, position_level: '1', rate: row.Rate, pay_type: row?.PayType?.name, employee_id: row.EmployeeId, vehicle_allowance: row?.VehicleAllowance })
        setOpenPay(true)
    }

    function editPayClose() {
        setOpenPay(false)
    }

    let table = {
        header: PayDetailsHeader,
        rows: data?.map(row => [
            // row?.EmployeeId,
            row?.PayType?.name || "N/A",
            row?.Rate ? `$ ${row?.Rate}` : "N/A",
            row?.VehicleAllowance ? `$ ${row?.VehicleAllowance}` : "N/A",
            moment(row?.EffectiveDate).format('MM-DD-YYYY') || "N/A",
            roleManager("employeeLookup", "sections", "PayDetails") && (
                <Button onClick={() => onEditClick(1, row)} className="EditIcon"></Button>
            )


        ])
    }


    let payModalData = {
        openModalPay: openPay,
        // openModalPay: updatePay,
        closePayModal: editPayClose,
        paytypeDropdown,
        setUpdatePay,
        updatePay,
        onUpdatePay,
        setUpdatePayDate,
        updatePayDate,

        task: null

    }
    const onEditClick = (type = 1, row) => {

        if (type == 1) {
            setUpdatePay({
                ...updatePay,
                position_level: '1',
                rate: row.Rate,
                pay_type: { title: row?.PayType?.name, id: row?.PayType?.id },
                employee_id: row.EmployeeId,
                id: row?.id,
                vehicle_allowance: row?.VehicleAllowance,
                // updatedAt: moment(row?.EffectiveDate)?.utc()?.format('MM-DD-YYYY'),
                updatedAt: new Date(row?.EffectiveDate),

                task: 'edit'
            })
        }
        if (type == 2)
            setUpdatePay({
                employee_id: employeeDetails?.id,
                pay_type: row?.employeeDetails?.payType,
                vehicle_allowance: updatePay?.vehicle_allowance,
                task: 'add'
            })
        setOpenPay(true)
    }




    return (
        <>
            <Grid xs={12} className="">
                <Grid item xs={9} style={{ marginBottom: '10px' }}>
                    {roleManager("employeeLookup", "sections", "PayDetails") && (
                        <Button style={{ marginTop: "20px" }} className="LinkButton" onClick={() => onEditClick(2)}>NEW PAY DETAILS</Button>
                    )}
                </Grid>


            </Grid>
            <Grid xs={12}  >
                <DynamicTable tableData={table} />
            </Grid>

            <PayDetailsModal upadteModalPay={payModalData} />
        </>
    )
}

export default PayDetails